// customDrawInteractions.js — Registry for bespoke per-DrawRule draw interaction factories.
//
// A factory is:
//   (map, opts) → { interaction, getPlacedCount(), destroy() }
//
// opts shape:
//   { sidc, minPoints, maxPoints, drawRule, onFinish(coords: [lng,lat][]) }
//
// onFinish delivers the final coordinate array in canonical DrawRule point order
// and hands control back to useMapEditor's commit path.
//
// Usage:
//   registerDrawInteraction(DrawRules.LINE12, myFactory);
//   const factory = getDrawInteractionFactory(DrawRules.LINE12); // → factory | null

const _registry = new Map();

/**
 * @param {number} drawRule
 * @param {(map: import('ol/Map').default, opts: object) => {
 *   interaction: object,
 *   getPlacedCount(): number,
 *   destroy(): void
 * }} factory
 */
export function registerDrawInteraction(drawRule, factory) {
    _registry.set(drawRule, factory);
}

/**
 * @param {number} drawRule
 * @returns {Function | null}
 */
export function getDrawInteractionFactory(drawRule) {
    return _registry.get(drawRule) ?? null;
}
